import { createAsyncThunk } from '@reduxjs/toolkit';
import { IDealerPortalFreeShippingConfig } from '../';
import { httpService } from '../../..';
import { executeApiRequest } from '../../asyncUtils';
import { uiActionCreators } from '../../ui';

export const updateDpFreeShippingConfigThunk = createAsyncThunk(
  'config/updateDpFreeShipping',
  async (config: IDealerPortalFreeShippingConfig, { dispatch, rejectWithValue }) => {
    dispatch(uiActionCreators.showSpinnerDialog());
    const response = await executeApiRequest<IDealerPortalFreeShippingConfig>(() =>
      httpService.post('/Admin/DealerPortal/Config', config)
    );
    dispatch(uiActionCreators.hideSpinnerDialog());

    if (response.requestFailed) {
      return rejectWithValue('Failed to update dealer portal free shipping config');
    }

    return response.value;
  }
);
